import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpHeaders } from '@angular/common/http';

@NgModule({
	declarations: [],
	imports: [
		CommonModule
	]
})
export class ConstantsModule {

	private _prefix: string = "https";
	private _url: string = "webftp.abdp.fr";
	private _port: string = "80";

    private _version: string = "v0";

	// Cookies definition.
	private _cookieUsername: string = "abdp-services-username";
	private _cookieToken: string = "abdp-services-token";
	private _cookieRole: string = "abdp-services-role";

	// MAILS TEMPLATES.
	// Template 'Folder creation'.
	private _mailTemplateFolderCreationIntro: string = "<p>" +
		"Bonjour,<br>" +
		"<br>" +
		"Nous vous informons ..." +
		"</p>";
	private _mailTemplateFolderCreationLink: string = "<p>" +
		"Aussi, afin que vous puissiez accéder à ce dossier, nous vous invitons à vous connecter à notre serveur via le lien " +
		"<a href='https://webftp.abdp.fr'>https://webftp.abdp.fr</a>." +
		"</p>";
	private _mailTemplateFolderCreationInfoBill: string = "<p>" +
		"<strong>Tout devis autres que les DPGF fournis ne seront pas pris en compte et <u>la Police Unique de Chantier" +
		" (PUC) et le Prorata doivent être inclus dans votre / vos devis</u>.</strong>" +
		"</p>";
	private _mailTemplateFolderCreationInfoAnswer: string = "<p>" +
		"<strong><u>Votre offre doit être déposée sur notre serveur au plus tard le <span style='background-color:yellow;'>XXXXXXXXX</span></u></strong> à l'aide de vos informations de connexion."+
		"</p>";
	private _mailTemplateFolderCreationNota: string = "<p><strong><u>Nota:</u></strong> " +
		"</p>";
	private _mailTemplateFolderCreationLinkValid: string = "<p><span style='background-color:yellow;'>" +
		"Nous vous remercions, par avance de bien vouloir utiliser les liens ci-dessous afin de nous faire " +
		"part de votre intention de participer ou pas à cet Appel d'Offre." +
		"</span><br>" +
		"<br>" +
		"Je compte répondre à cette offre: LIEN_OK<br>" +
		"Je ne compte <strong>pas</strong> répondre à cette offre: LIEN_KO<br>" +
		"</p>";
	private _mailTemplateFolderCreationMoreInfo: string = "<p>" +
		"<strong><u>Pour information:</u></strong><br>" +
		"<ul>" +
		"<li><strong><u>Démarrage des travaux:</u></strong> du</li>" +
		"</ul>" +
		"</p>";
	private _mailTemplateFolderCreationSignature: string = "<p>" +
		"Dans l'attente,<br>" +
		"Bien cordialement<br>" +
		"Le secrétariat<br>" +
		"Pour M. Pierre MAILLOT<br>" +
		"<br>" +
		"<strong>ATELIER BELLET de PINA SAS</strong><br>" +
		"<strong>Architectes Associés</strong><br>" +
		"<br>" +
		"16, rue de Solférino<br>" +
		"92100 BOULOGNE BILLANCOURT<br>" +
		"Tel: 01.40.84.01.23 - Fax: 01.40.84.91.23<br>" +
		"Email: <a href='mailto:abdp.92@abdp.fr'>abdp.92@abdp.fr</a><br>" +
		"&nbsp; &nbsp; &<br>" +
		"Rue Charles Duchesne - Le Mercure C<br>" +
		"13851 Aux en Provence cedex 3<br>" +
		"Tel: 04.42.24.35.33 - Fax: 04.42.24.20.75<br>" +
		"Email: <a href='mailto:abdp.aix@abdp.fr'>abdp.aix@abdp.fr</a>" +
		"</p>";
	// Template 'Folder reminder'.
	private _mailTemplateFolderReminderSubject: string = "Atelier Bellet de Pina: Rappel de projet lancé";
	private _mailTemplateFolderReminder: string = "<p>" +
		"Bonjour,<br>" +
		"<br>" +
		"Nous avons lancé un projet il y a quelques temps et sauf erreur de notre part, vous n'avez pas donné suite à celui-ci.<br>" +
		"<br>" +
		"Pour rappel, vous pouvez vous connecter à notre serveur de partage à l'adresse suivante <a href='https://webftp.abdp.fr'>https://webftp.abdp.fr</a>.<br>" +
		"<br>" +
		"Si vous envisagez de donner suite à ce projet, merci de cliquer sur le lien: LIEN_OK<br>" +
		"En revanche, pour ne pas donner suite, merci de cliquer sur le lien: LIEN_KO<br>" +
		"<br>" +
		"16, rue de Solférino<br>" +
		"92100 BOULOGNE BILLANCOURT<br>" +
		"Tel: 01.40.84.01.23 - Fax: 01.40.84.91.23<br>" +
		"Email: <a href='mailto:abdp.92@abdp.fr'>abdp.92@abdp.fr</a><br>" +
		"&nbsp; &nbsp; &<br>" +
		"Rue Charles Duchesne - Le Mercure C<br>" +
		"13851 Aux en Provence cedex 3<br>" +
		"Tel: 04.42.24.35.33 - Fax: 04.42.24.20.75<br>" +
		"Email: <a href='mailto:abdp.aix@abdp.fr'>abdp.aix@abdp.fr</a>" +
		"</p>";

	private _mailTemplateFolderUpdaterSubject: string = "Atelier Bellet de Pina: Modification de fichier dans un projet";
	private _mailTemplateFolderUpdater: string = "<p>" +
		"Bonjour,<br>" +
		"<br>" +
		"Nous vous informons qu'un ou plusieur fichier(s) d'un projet auquel vous faites partie ont été modifié.<br>" +
		"<br>" +
		"Pour rappel, vous pouvez vous connecter à notre serveur de partage à l'adresse suivante <a href='https://webftp.abdp.fr'>https://webftp.abdp.fr</a>.<br>" +
		"<br>" +
		"Si vous envisagez de donner suite à ce projet, merci de cliquer sur le lien: LIEN_OK<br>" +
		"En revanche, pour ne pas donner suite, merci de cliquer sur le lien: LIEN_KO<br>" +
		"<br>" +
		"16, rue de Solférino<br>" +
		"92100 BOULOGNE BILLANCOURT<br>" +
		"Tel: 01.40.84.01.23 - Fax: 01.40.84.91.23<br>" +
		"Email: <a href='mailto:abdp.92@abdp.fr'>abdp.92@abdp.fr</a><br>" +
		"&nbsp; &nbsp; &<br>" +
		"Rue Charles Duchesne - Le Mercure C<br>" +
		"13851 Aux en Provence cedex 3<br>" +
		"Tel: 04.42.24.35.33 - Fax: 04.42.24.20.75<br>" +
		"Email: <a href='mailto:abdp.aix@abdp.fr'>abdp.aix@abdp.fr</a>" +
		"</p>";


  private _httpOptions = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json'
    })
  };

  constructor() {
  }

  // Server retrieving.
  get serverURL() : string { return this._url; }
  get serverPort(): string { return this._port; }
  get serverURLWithPort(): string {
      if (this._port != "80") {
          return this._url + ":" + this._port;
      } else {
          return this._url;
      }
  }
  get serverFullURL(): string {
      if (this._port != "80") {
          return this._prefix + "://" + this._url + ":" + this._port + "/" + this._version;
      } else {
          return this._prefix + "://" + this._url + "/" + this._version;
      }
  }
  get httpOptions() { return this._httpOptions; };

  // Cookies retrieving.
  get cookieUser(): string { return this._cookieUsername; }
  get cookieToken(): string { return this._cookieToken; }
  get cookieRole(): string { return this._cookieRole; }

	// Mail template.
	get mailTemplateFolderCreationIntro(): string { return this._mailTemplateFolderCreationIntro; }
	get mailTemplateFolderCreationLink(): string { return this._mailTemplateFolderCreationLink; }
	get mailTemplateFolderCreationInfoBill(): string { return this._mailTemplateFolderCreationInfoBill; }
	get mailTemplateFolderCreationInfoAnswer(): string { return this._mailTemplateFolderCreationInfoAnswer; }
	get mailTemplateFolderCreationNota(): string { return this._mailTemplateFolderCreationNota; }
	get mailTemplateFolderCreationLinkValid(): string { return this._mailTemplateFolderCreationLinkValid; }
	get mailTemplateFolderCreationMoreInfo(): string { return this._mailTemplateFolderCreationMoreInfo; }
	get mailTemplateFolderCreationSignature(): string { return this._mailTemplateFolderCreationSignature; }
	get mailTemplateFolderReminderSubject(): string { return this._mailTemplateFolderReminderSubject; }
	get mailTemplateFolderReminder(): string { return this._mailTemplateFolderReminder; }
	get mailTemplateFolderUpdaterSubject(): string { return this._mailTemplateFolderUpdaterSubject; }
	get mailTemplateFolderUpdater(): string { return this._mailTemplateFolderUpdater; }
}
